import Flickity from 'flickity'

export default () => {
    let slider = document.querySelector('body .reviews .carousel')
    let left = document.querySelector('body .reviews .carousel .flickity-button-left')
    let right = document.querySelector('body .reviews .carousel .flickity-button-right')

    let options = {
        cellSelector: '.quote',
        pageDots: true,
        contain: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        autoPlay: false,
        wrapAround: true,
        cellAlign: 'center',
        groupCells: false,
        draggable: '>1',
        watchCSS: false
    }

    var flkty = new Flickity (slider, options)

    left.addEventListener( 'click', function() {
        flkty.previous()
    });
    right.addEventListener( 'click', function() {
        flkty.next()
    });

}

